import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, Col, Row, Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import signatureService from '../../services/signature/SignatureService'

export default function SignedDocumentPage() {
    const { documentId } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    const [signedUrl, setSignedUrl] = useState('')
    const [documentInfo, setDocumentInfo] = useState(null)

    useEffect(() => {
        let active = true
        let objectUrl = ''

        const load = async () => {
            setLoading(true)
            setError('')

            try {
                const statusRes = await signatureService.getStatus(documentId)
                const status = statusRes?.data || {}
                const signed = status.signed || status.status === 'SIGNED'

                if (!signed) {
                    if (active) {
                        setError('Dokumen belum berstatus SIGNED.')
                    }
                    return
                }

                const fileRes = await signatureService.downloadSigned(documentId)
                objectUrl = URL.createObjectURL(fileRes.data)

                if (active) {
                    setSignedUrl(objectUrl)
                    setDocumentInfo(status)
                }
            } catch (e) {
                if (active) {
                    setError(e?.response?.data?.message || 'Dokumen yang sudah ditandatangani tidak dapat dimuat.')
                }
            } finally {
                if (active) {
                    setLoading(false)
                }
            }
        }

        load()

        return () => {
            active = false
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl)
            }
        }
    }, [documentId])

    const download = () => {
        if (!signedUrl) return

        const link = document.createElement('a')
        link.href = signedUrl
        link.download = `signed-${documentId}.pdf`
        document.body.appendChild(link)
        link.click()
        link.remove()
    }

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" />
                <div className="mt-2 text-muted">Memuat dokumen yang sudah ditandatangani...</div>
            </div>
        )
    }

    return (
        <div className="container-fluid py-4">
            <Card className="mb-4 bg-transparent border-0 shadow-none">
                <Card.Body className="px-1 py-0">
                    <Row className="align-items-end">
                        <Col md={8}>
                            <h3 className="text-white fw-bold mb-2">Dokumen Sudah Ditandatangani</h3>
                            <div className="text-white">
                                Dokumen ini sudah selesai ditandatangani dan hanya dapat dilihat atau diunduh.
                            </div>
                        </Col>
                        <Col md={4} className="d-flex justify-content-md-end gap-2 mt-3 mt-md-0">
                            <Button variant="warning" onClick={() => navigate(-1)}>
                                Kembali
                            </Button>
                            {signedUrl && (
                                <Button variant="primary" onClick={download}>
                                    Unduh PDF
                                </Button>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {error && (
                <Alert variant="danger">
                    {error}
                    <div className="mt-3">
                        <Button variant="outline-danger" onClick={() => navigate('/notifications')}>
                            Kembali ke Notifikasi
                        </Button>
                    </div>
                </Alert>
            )}

            {!error && (
                <Card>
                    <Card.Body>
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <small className="text-muted">Dokumen ID</small>
                                <div>{documentId}</div>
                            </div>
                            <div className="col-md-4">
                                <small className="text-muted">Tahap Signature</small>
                                <div>{documentInfo?.signatureStage || documentInfo?.stage || '-'}</div>
                            </div>
                            <div className="col-md-4">
                                <small className="text-muted">Status</small>
                                <div className="text-success fw-semibold">Sudah Ditandatangani</div>
                            </div>
                        </div>

                        {signedUrl && (
                            <iframe
                                title="Dokumen PDF Signed"
                                src={signedUrl}
                                style={{
                                    width: '100%',
                                    height: '75vh',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px'
                                }}
                            />
                        )}
                    </Card.Body>
                </Card>
            )}
        </div>
    )
}
